import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { User } from "./nswag/nswagclient";

@Injectable()
export abstract class IUserManagerService{
    abstract getCurrentUser():Observable<User>;
    abstract getIsEditorOrAdmin():Observable<boolean>;
}